module.exports = __webpack_public_path__ + "static/share-0ee565adedfb98e1f26575762ec4452a.jpg";